import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    dialog_filter: false,
    showDetails: false,
    loading: false,
    order_column: 'created_at',
    order_type: 'asc',
    page: 1,
    page_size: 30,
    filter: {},
    claimsByLabel: [],
    claimList: [],
    todayList: [],
    label: {},
    showDescriptionModal: false,
    selectedDescription: ''
  },

  mutations: {
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogFilter(state, payload) {
       state.dialog_filter = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setClaimsByLabel(state, payload) {
      state.claimsByLabel = payload
    },
    setClaimList(state, payload) {
      state.claimList = payload
    },
    setTodayList(state, payload) {
      state.todayList = payload
    },
    setSelectedLabel(state, payload) {
      state.label = payload
    },
    setShowDetails(state, payload) {
      state.showDetails = payload
    },
    setShowDescriptionModal(state, payload) {
      state.showDescriptionModal = payload
    },
    setSelectedDescription(state, payload) {
      state.selectedDescription = payload
    },
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/claim-log', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setClaimsByLabel',r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    getDetails({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/claim-log/' + state.label , {
            params: {
              page: state.page,
              page_size: state.page_size,
              order_column: state.order_column,
              order_type: state.order_type,
              ...state.filter
            }
          })
          .then(r => {
            commit('setClaimList',r.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    getTodayClaims({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/claim-log-today', {
            params: {
              page: state.page,
              page_size: state.page_size,
              order_column: state.order_column,
              order_type: state.order_type,
              ...state.filter
            }
          })
          .then(r => {
            commit('setTodayList',r.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    }
  }
}
